import { Trans, useLingui } from '@lingui/react/macro';
import { format, parseISO } from 'date-fns';

import type { Appointment } from '../../../react-query/useAppointments';

import { getProviderName } from './helpers';
import {
  PrivateDateOfBirth,
  PrivatePatientName,
} from './privatePatientDetails';

export const PatientCell = ({ appointment }: { appointment: Appointment }) => {
  const { i18n, t } = useLingui();

  return (
    <>
      <PrivatePatientName appointment={appointment} />
      <p className="vai-typography-p vai-text-lg">
        {format(parseISO(appointment.appointment.start), 'hh:mm aaa')}
      </p>
      <div className="vai-mt-1">
        <p className="vai-typography-small !vai-font-normal">
          <Trans>Operatory: </Trans>
          {appointment.appointment.operatory?.name ?? t`Unknown`}
        </p>
        {appointment.patient.isNewPatient && (
          <p className="vai-typography-small !vai-font-normal">
            <Trans>NEW</Trans>
          </p>
        )}
        <p className="vai-typography-small !vai-font-normal">
          <Trans>Provider: </Trans>
          {getProviderName(appointment.appointment.provider)}
        </p>
        <PrivateDateOfBirth appointment={appointment} />
        {appointment.appointment.imagesAt && (
          <p className="vai-typography-small !vai-font-normal">
            <Trans>Last images taken </Trans>
            {i18n.date(new Date(appointment.appointment.imagesAt), {})}
          </p>
        )}
      </div>
    </>
  );
};
